import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container pb-20" }
const _hoisted_2 = { class: "flex justify-end gap-x-2" }
const _hoisted_3 = { class: "lg:hidden mb-8" }
const _hoisted_4 = { class: "lg:flex relative gap-x-10" }
const _hoisted_5 = {
  key: 0,
  class: "w-[300px]"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "fixed z-20 bg-neutral-900/20 inset-0" }
const _hoisted_8 = { class: "z-20 fixed flex flex-col justify-end inset-0" }
const _hoisted_9 = { class: "h-[80vh] bg-white rounded-t flex flex-col" }
const _hoisted_10 = { class: "flex-1 overflow-y-scroll px-4 py-4" }
const _hoisted_11 = { class: "border-t border-neutral-200 flex justify-center px-4 py-2" }
const _hoisted_12 = { class: "flex-1" }

import { ref, watch } from 'vue';
import ProductList from "./ProductList.vue";
import ProductFilters from "./ProductFilters.vue";
import ActiveFilters from "./ActiveFilters.vue";
import ProductSort from './ProductSort.vue';
import { useWindowResize } from '@/js/helpers/windowResize';

export default /*@__PURE__*/_defineComponent({
  __name: 'ProductDatabase',
  setup(__props) {

const showFilters = ref(false);
watch(showFilters, (newVal) => {
  if (newVal) {
    document.querySelector('body')?.classList.add('overflow-hidden', 'h-screen');
  } else {
    document.querySelector('body')?.classList.remove('overflow-hidden', 'h-screen');
  }
});
const windowWidth = useWindowResize().width;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showFilters.value = !showFilters.value), ["prevent"])),
          class: "px-3 py-2 rounded border border-teal text-teal flex font-medium items-center gap-x-2"
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("span", null, _toDisplayString('Vis filter'), -1),
          _createElementVNode("span", { class: "material-symbols-outlined" }, "filter_list", -1)
        ]))
      ]),
      _createVNode(ProductSort)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_unref(windowWidth) >= 1024)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(ProductFilters)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_Transition, {
              class: "transition-all",
              "enter-from-class": "opacity-0",
              "enter-to-class": "opacity-100",
              "leave-from-class": "opacity-100",
              "leave-to-class": "opacity-0"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_7, null, 512), [
                  [_vShow, showFilters.value]
                ])
              ]),
              _: 1
            }),
            _createVNode(_Transition, {
              class: "transition-all",
              "enter-from-class": "opacity-0 translate-y-full",
              "enter-to-class": "opacity-100 translate-y-0",
              "leave-from-class": "opacity-100 translate-y-0",
              "leave-to-class": "opacity-0 translate-y-full"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex justify-between items-center px-4 py-2 border-b border-neutral-200" }, [
                      _createElementVNode("div", { class: "font-medium" }, _toDisplayString('Filtrer resultater'))
                    ], -1)),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(ProductFilters)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("button", {
                        class: "bg-teal rounded text-white px-3 py-2 font-medium",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (showFilters.value = false), ["prevent"]))
                      }, _toDisplayString('Vis resultater'))
                    ])
                  ])
                ], 512), [
                  [_vShow, showFilters.value]
                ])
              ]),
              _: 1
            })
          ])),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(ActiveFilters),
        _createVNode(ProductList)
      ])
    ])
  ]))
}
}

})